import { createContext, useCallback, useMemo, useState, useContext } from "react";

interface IDrawerOptions {
    codigo: number;
    path: string;
    icon: any;
    label: string;
    visible?: boolean;
    subMenu: IDrawerOptions[];
    href?: string;
    target?: string;
}

interface IDrawerContextData {
    isDrawerOpen: boolean;   
    toggleDrawerOpen: () => void;
    drawerOptions: IDrawerOptions[];
    setDrawerOptions: (newDrawerOptions: IDrawerOptions[]) => void;
}

type Props = {
    children?: React.ReactNode,
};

const DrawerContext = createContext<IDrawerContextData>({} as IDrawerContextData);

export const useDrawerContext = () => {
    return useContext(DrawerContext);
}

export const DrawerProvider: React.FC<Props> = ({ children }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [drawerOptions, setDrawerOptions] = useState<IDrawerOptions[]>([]);

    const toggleDrawerOpen = useCallback(() => {

        setIsDrawerOpen(oldDrawerOpen => !oldDrawerOpen);
    }, []);


    const handleSetDrawerOptions = useCallback((newDrawerOptions: IDrawerOptions[]) => {
        setDrawerOptions(newDrawerOptions);
    }, []);


    return (
        <DrawerContext.Provider value={{ isDrawerOpen, drawerOptions, toggleDrawerOpen, setDrawerOptions: handleSetDrawerOptions }}>
            {children}
        </DrawerContext.Provider>
    );
}